export default __webpack_public_path__ + "static/media/rent-first.5ad6d734.jpg";